module.exports = __webpack_public_path__ + "img/banner.39b3cfdc.png";